import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f1d3544")

_pushScopeId("data-v-4f1d3544")
const _hoisted_1 = { class: "flex align-center w-full" }
const _hoisted_2 = { class: "font-bold font-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = { class: "margin-right-10" }
const _hoisted_5 = { class: "image" }
const _hoisted_6 = { class: "card-text" }
const _hoisted_7 = { class: "tags" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { accordion: "" }, {
      default: _withId(() => [
        _createVNode(_component_el_collapse_item, null, {
          title: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, "按标签过滤: " + _toDisplayString(_ctx.filterTags.length === 0 ? '全部' : ''), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterTags, (tag) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: tag.id,
                  closable: "",
                  onClose: ($event: any) => (_ctx.clickTag(tag))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClose"]))
              }), 128)),
              _hoisted_3,
              _createVNode("div", null, "卡牌总计：" + _toDisplayString(_ctx.alternativeCards.length), 1)
            ])
          ]),
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonCardTagCategories.filter(c => c.tags.length > 0), (category) => {
              return (_openBlock(), _createBlock("div", {
                key: category.tagCategoryId
              }, [
                _createVNode("strong", _hoisted_4, _toDisplayString(category.tags[0].category.name) + ":", 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.tags, (tag) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: tag.id,
                    onClick: ($event: any) => (_ctx.clickTag(tag)),
                    type: _ctx.isSelectedTag(tag.id) ? 'primary' : 'info'
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(tag.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "type"]))
                }), 128))
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode("div", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alternativeCards, (card) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          class: "card",
          key: card.id
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                onClick: ($event: any) => (_ctx.changeCardConfirmed(card)),
                class: "image",
                src: card.cardUrl
              }, null, 8, ["onClick", "src"]),
              _createVNode("div", _hoisted_6, _toDisplayString(card.cardText), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(card.cardTags, (cardTag) => {
                return (_openBlock(), _createBlock(_component_el_tag, { key: cardTag }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTag(cardTag.tagId).name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ], 64))
})